export { default } from './BarchartWidgetBars';
